const dtf = new Intl.DateTimeFormat('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' });
export const fmtWhen = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : dtf.format(d);
};

const hm = new Intl.DateTimeFormat('he-IL', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' });
const dm = new Intl.DateTimeFormat('he-IL', { day: '2-digit', month: '2-digit', timeZone: 'Asia/Jerusalem' });
const dayKey = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Jerusalem' });

/** "14:05" אם היום (שעון ישראל), אחרת "07.10 14:05". */
export const fmtClock = (iso: string, now = new Date()) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return dayKey.format(d) === dayKey.format(now) ? hm.format(d) : `${dm.format(d)} ${hm.format(d)}`;
};

/** "לפני 4 דק'" / "לפני 3 שע'" / "לפני 2 ימים" / "עכשיו". */
export const fmtAgo = (iso: string, now = Date.now()) => {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const min = Math.max(0, Math.round((now - t) / 60_000));
  if (min < 1) return 'עכשיו';
  if (min < 60) return `לפני ${min} דק'`;
  const h = Math.round(min / 60);
  if (h < 24) return `לפני ${h} שע'`;
  const d = Math.round(h / 24);
  return d === 1 ? 'לפני יום' : `לפני ${d} ימים`;
};

/** artifacts-report-cache: "לפני רגע" / "לפני דקה" / "לפני 12 דקות" / "לפני שעה" / "לפני שעתיים" / "לפני 5 שעות" / "לפני יום" / "לפני יומיים" / "לפני 3 ימים". */
export const fmtAgoWords = (iso: string, now = Date.now()) => {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const min = Math.max(0, Math.floor((now - t) / 60_000));
  if (min < 1) return 'לפני רגע';
  if (min < 60) return min === 1 ? 'לפני דקה' : `לפני ${min} דקות`;
  const h = Math.floor(min / 60);
  if (h < 24) return h === 1 ? 'לפני שעה' : h === 2 ? 'לפני שעתיים' : `לפני ${h} שעות`;
  const d = Math.floor(h / 24);
  return d === 1 ? 'לפני יום' : d === 2 ? 'לפני יומיים' : `לפני ${d} ימים`;
};

/**
 * 11 (2026-10-16) קיפול התור: כמה זמן עבד — finishedAt − startedAt מהשרת. "עבד 42 שנ'" מתחת לדקה, "עבד 1:47 דק'",
 * "עבד 1:02:05 שע'" משעה. null — אחד הזמנים חסר.
 */
export const fmtWorked = (startedAt: string | null, finishedAt: string | null): string | null => {
  if (!startedAt || !finishedAt) return null;
  const ms = Date.parse(finishedAt) - Date.parse(startedAt);
  if (!Number.isFinite(ms) || ms < 0) return null;
  const s = Math.max(1, Math.round(ms / 1000));
  if (s < 60) return `עבד ${s} שנ'`;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (s < 3600) return `עבד ${Math.floor(s / 60)}:${pad(s % 60)} דק'`;
  return `עבד ${Math.floor(s / 3600)}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)} שע'`;
};

const ymd = new Intl.DateTimeFormat('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Asia/Jerusalem' });

/**
 * כמה זמן עבר מאז שהתור נגמר (11): "לפני רגע" / "לפני דקה" / "לפני 3 דקות" / "לפני שעה" / "לפני שעתיים" / "לפני 5 שעות" /
 * "לפני יום" / "לפני 2 ימים"; מעל 7 ימים — התאריך (שעון ישראל). now — שעון הדפדפן (מתעדכן כל דקה), finishedAt — מהשרת.
 */
export const fmtSince = (iso: string, now = Date.now()): string => {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  const min = Math.floor(Math.max(0, now - t) / 60_000);
  if (min < 1) return 'לפני רגע';
  if (min < 60) return min === 1 ? 'לפני דקה' : `לפני ${min} דקות`;
  const h = Math.floor(min / 60);
  if (h < 24) return h === 1 ? 'לפני שעה' : h === 2 ? 'לפני שעתיים' : `לפני ${h} שעות`;
  const d = Math.floor(h / 24);
  if (d <= 7) return d === 1 ? 'לפני יום' : `לפני ${d} ימים`;
  return ymd.format(t);
};
